<template lang="pug">
  .flipepr-wrapper
    .card-flipper(:class="{flip: currentView === 1}")
      .front-flipper
        slot(name="front")
      .back-flipper
        slot(name="back")

</template>

<script>
export default {
  props: {
    currentView: {'default': 0}
  }
}
</script>

<style scoped lang="scss">
.flipepr-wrapper {
  height: inherit;
  width: 100%;

  .card-flipper {
    height: inherit;
    width: 100%;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
    -webkit-transform-style: preserve-3d;

    &.flip {
      .front-flipper {
        transform: rotateX(-180deg);
      }

      .back-flipper {
        transform: none;
      }
    }

    .front-flipper, .back-flipper {
      height: inherit;
      grid-column: 1;
      grid-row: 1;
      backface-visibility: hidden;
      transition-duration: 400ms;
      top: 0;
      width: 100%;
    }
    .front-flipper {
      transform: none;
    }
    .back-flipper {
      transform: rotateX(180deg);
    }

  }
}
</style>
